// extracted by mini-css-extract-plugin
export default {"placeholder-text":"placeholder-text__SfCpf","interests-tips":"interests-tips__8YGEV","interests-text":"interests-text__IR-10"};